/**
 * @generated SignedSource<<b5d5404776ea3842230a3052638534d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoPageAuthorizedData$data = {
  readonly authorizedData: {
    readonly captions: ReadonlyArray<{
      readonly lang: string | null | undefined;
      readonly uri: string;
    }>;
    readonly segments: ReadonlyArray<{
      readonly startTime: number;
      readonly uri: string;
    }>;
    readonly tracks: ReadonlyArray<{
      readonly flavor: string;
      readonly isMaster: boolean | null | undefined;
      readonly mimetype: string | null | undefined;
      readonly resolution: ReadonlyArray<number> | null | undefined;
      readonly uri: string;
    }>;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "VideoPageAuthorizedData";
};
export type VideoPageAuthorizedData$key = {
  readonly " $data"?: VideoPageAuthorizedData$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoPageAuthorizedData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uri",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "eventPassword"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "eventUser"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./VideoAuthorizedDataRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "VideoPageAuthorizedData",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "password",
          "variableName": "eventPassword"
        },
        {
          "kind": "Variable",
          "name": "user",
          "variableName": "eventUser"
        }
      ],
      "concreteType": "AuthorizedEventData",
      "kind": "LinkedField",
      "name": "authorizedData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Track",
          "kind": "LinkedField",
          "name": "tracks",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "flavor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mimetype",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resolution",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMaster",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Caption",
          "kind": "LinkedField",
          "name": "captions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lang",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "kind": "LinkedField",
          "name": "segments",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTime",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "AuthorizedEvent",
  "abstractKey": null
};
})();

(node as any).hash = "2c0e02fb2513d151675d9f1b4ec39870";

export default node;
